import accessPointsAccessMethodReducer from 'store/reducers/accessPointsAccessMethodReducer';
import accessPointsReducer from './accessPointsReducer';
import accounts from 'store/reducers/accountsReducer';
import accountUsersReducer from './accountUsersReducer';
import accountYieldsReducer from 'store/reducers/accountYieldsReducer';
import apikeys from 'store/reducers/apiKeysReducer';
import bookingReservationsReducer from 'store/reducers/bookingReservationsReducer';
import bookingsReducer from 'store/reducers/bookingsReducer';
import bookingStatsReducer from 'store/reducers/bookingStatsReducer';
import campaigns from 'store/reducers/campaignsReducer';
import categories from 'store/reducers/categoriesReducer';
import currentAccountsReducer from './currentAccountsReducer';
import dashboard from 'store/reducers/dashboardReducer';
import discountCodesReducer from 'store/reducers/discountCodesReducer';
import discountsReducer from 'store/reducers/discountsReducer';
import invoicesReducer from 'store/reducers/invoices/invoicesReducer';
import modal from 'store/reducers/modalReducer';
import notification from 'store/reducers/notificationReducer';
import orderBookingActivities from 'store/reducers/orderBookingActivitiesReducer';
import orders from 'store/reducers/ordersReducer';
import path from 'store/reducers/pathReducer';
import pointsofinterest from 'store/reducers/pointsofinterestReducer';
import pointsOfInterestImages from 'store/reducers/pointsOfInterest/pointsOfInterestImagesReducer';
import productImages from './products/productImagesReducer';
import productLocalisation from 'store/reducers/productLocalisationReducer';
import productOccupancy from './products/productOccupancyReducer';
import productProperties from 'store/reducers/productPropertiesReducer';
import productRelated from 'store/reducers/productRelatedReducer';
import products from 'store/reducers/productsReducer';
import properties from 'store/reducers/propertiesReducer';
import propertygroups from 'store/reducers/propertygroupsReducer';
import reservations from 'store/reducers/reservationsReducer';
import reservationSessionActivities from 'store/reducers/reservationAccessSessionActivitiesReducer';
import subcategories from 'store/reducers/subcategoriesReducer';
import transactions from 'store/reducers/transactionsReducer';
import uiReducer from 'store/reducers/uiReducer';
import usersReducer from 'store/reducers/usersReducer';
import webhooksReducer from 'store/reducers/webhooksReducer';
import productMembershipsReducer from './productMembershipsReducer';
import membershipSchedulesReducer from './membershipSchedulesReducer';
import userProductMembershipsReducer from './userProductMembershipsReducer';
import userProductMembershipPoolReducer from './userProductMembershipPoolReducer';
import membershipPoolsReducer from './membershipPoolsReducer';

export default {
    'access-points': accessPointsReducer,
    'access-points-access-methods': accessPointsAccessMethodReducer,
    accounts: accounts,
    account_yields: accountYieldsReducer,
    'account-users': accountUsersReducer,
    'api-keys': apikeys,
    'booking-stats': bookingStatsReducer,
    bookingReservations: bookingReservationsReducer,
    bookings: bookingsReducer,
    campaigns: campaigns,
    categories: categories,
    'current-account': currentAccountsReducer,
    dashboard: dashboard,
    'discount-codes': discountCodesReducer,
    discounts: discountsReducer,
    invoices: invoicesReducer,
    'membership-schedules': membershipSchedulesReducer,
    modal: modal,
    notification: notification,
    orders: orders,
    path: path,
    pointsofinterest: pointsofinterest,
    pointsOfInterestImages: pointsOfInterestImages,
    productOccupancy: productOccupancy,
    productRelated: productRelated,
    productImages: productImages,
    products: products,
    'product-memberships': productMembershipsReducer,
    properties: properties,
    propertygroups: propertygroups,
    reservations: reservations,
    subcategories: subcategories,
    transactions: transactions,
    ui: uiReducer,
    users: usersReducer,
    webhooks: webhooksReducer,
    orderBookingActivities: orderBookingActivities,
    productLocalisation: productLocalisation,
    productProperties: productProperties,
    reservationSessionActivities: reservationSessionActivities,
    userProductMemberships: userProductMembershipsReducer,
    'user-product-membership-pool': userProductMembershipPoolReducer,
    'membership-pools': membershipPoolsReducer,
};



// WEBPACK FOOTER //
// ./src/store/reducers/reducers.js